var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "article-paragraph container-fluid mb-3"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-11 col-md-10 col-lg-6"
  }, [_c('h2', {
    staticClass: "h5 font-weight-semibold mb-4",
    domProps: {
      "textContent": _vm._s(_vm.currentPayload.title)
    }
  }), _vm._v(" "), _c('GlobalRichText', {
    attrs: {
      "payload": _vm.currentPayload.text
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };